$(function () {
  function statusChangeCallback(response) {
    if (response.status === 'connected') {
      signUp(response.authResponse);
    } else {
     FB.login(function(response) {
        if (response.authResponse) {
          signUp(response.authResponse);
        }
      }, {scope: '{/literal}{$fb_app_scope}{literal}'})
    }
  }
  function checkLoginState() {
    FB.getLoginStatus(function(response) {
       statusChangeCallback(response);
    });
  }
  function signUp(response) {
    $.fancybox.showLoading()
    $.ajax({
        url: '/fb-login'
      , data: {
            'userID': response.userID
          , 'accessToken': response.accessToken
          , 'signedRequest': response.signedRequest
          , 'expiresIn': response.expiresIn
        }
      , type: 'POST'
      , success: function (data, textStatus, jqXHR) {
          $.fancybox.hideLoading()
          if (data.user){
            location.reload();
          }
        }
      , error: function () {
          $.fancybox.hideLoading()
        }
    })
  }
  $('body').on('click', '[data-behaviour=fb-login]', function (e) {
    e.preventDefault()
    FB.login(function(response) {
      statusChangeCallback(response)
    }, {
      scope: 'email,public_profile'
    });
  });
  $('[data-behaviour~=toggle-login]').click(function (e) {
    e.preventDefault()
    var $popup = $('#popup-login')
    if ($popup.is(':visible')) {
      $popup.fadeOut().find('.error').hide()
    } else {
      $popup.fadeIn().find('input').first().focus()
    }
  })
  $('[data-behaviour~=login-form]').submit(function (e) {
    e.preventDefault()
    var $form = $(e.target).closest('form')
    $.ajax({
        url: $form.attr('action')
      , data: $form.serialize()
      , type: 'POST'
      , success: function (data, statusText, jqXHR) {
          if (data.status == 'OK') {
            if (data.location) {
              self.location.href = data.location
            } else {
              self.location.reload()
            }
          } else {
            $form.find('input[type=password]').val('').focus()
            $form.find('.error').show()
          }
        }
    })
  })
})
